import logo from '@/assets/images/logo.svg';
import Button from '@/components/UI/Button';
import * as Auth from '@/support/auth.ts';
import { type FC, useState } from 'react';

export const UnSupportedClientVersion: FC = () => {
  const [updating, setUpdating] = useState(false);

  const clearCacheAndReload = async () => {
    setUpdating(true);
    const reloadURL = new URL(window.location.origin);
    reloadURL.searchParams.set('version', new Date().getTime().toString());
    await Auth.logout({ type: 'outdated-client', redirectTo: reloadURL.href });
  };
  return (
    <div
      className="flex flex-row justify-around mt6-l"
      data-test-component="UnSupportedClientVersion"
      data-test-element="container"
    >
      <div className="flex flex-column justify-center ui-card w-30 pa4">
        <div className="flex flex-row justify-around">
          <img src={logo} alt="Benchling In Vivo" style={{ width: 150, height: 60 }} />
        </div>

        <div className="flex flex-row justify-around mt4">
          <h3 className="normal f4">Outdated Client</h3>
        </div>
        <p className="tc mt4">
          You are using an outdated version of Benchling In Vivo. Please update by clicking the button below.
        </p>
        <Button className="w-100 mt4" disabled={updating} testId="update-now-button" onClick={clearCacheAndReload}>
          Update now
        </Button>
      </div>
    </div>
  );
};
